import { HasFactoryWaterMark } from '../../../../classes/class-helpers/factory';
import { ConstructClassWithPrivateMembers } from '../../../../misc/helpers/ClassWithPrivateMembers';
import { DISTINCT_VALUE_OBSERVABLE_PRIVATE } from './privates';
import { InitObservableHook } from '../../../../core/observable/hook/init';
import { IsObject } from '../../../../helpers';
import { NewDistinctValueObservableContext } from './context/implementation';
export function ConstructDistinctValueObservable(instance, context, create) {
    ConstructClassWithPrivateMembers(instance, DISTINCT_VALUE_OBSERVABLE_PRIVATE);
    const privates = instance[DISTINCT_VALUE_OBSERVABLE_PRIVATE];
    privates.context = context;
    privates.count = 0;
    privates.lastCountPerObserver = new WeakMap();
    InitObservableHook(instance, privates, NewDistinctValueObservableContext, create);
}
export function IsDistinctValueObservable(value) {
    return IsObject(value)
        && value.hasOwnProperty(DISTINCT_VALUE_OBSERVABLE_PRIVATE);
}
export const IS_VALUE_OBSERVABLE_CONSTRUCTOR = Symbol('is-value-observable-constructor');
export function IsDistinctValueObservableConstructor(value) {
    return (typeof value === 'function')
        && HasFactoryWaterMark(value, IS_VALUE_OBSERVABLE_CONSTRUCTOR);
}
//# sourceMappingURL=constructor.js.map